const ls = {
  get: () => JSON.parse(localStorage.getItem("recentlyViewed")),
  set: val => localStorage.setItem("recentlyViewed", JSON.stringify(val)),
};

export const updateRecentProducts = product => {
  let recentlyViewed = [];

  if (ls.get() !== null) {
    recentlyViewed = ls.get().filter(item => item.id !== product.id);

    recentlyViewed.unshift(product);
    ls.set(recentlyViewed.slice(0, 20));
  } else if (ls.get() === null) {
    recentlyViewed.push(product);
    ls.set(recentlyViewed);
  }
};

export const resetRecentProducts = () =>
  localStorage.removeItem("recentlyViewed");

export const getRecentProducts = () => ls.get();
